import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/login-bg_bottom.png'
import _imports_1 from '@/assets/wachat.png'


const _withScopeId = n => (_pushScopeId("data-v-bbf74d86"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "l-mask"
}
const _hoisted_2 = { class: "l-login" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l-login__sayhi" }, "Hi 您好", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l-login__sayhi" }, "欢迎登陆，中通招聘官网", -1))
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "login-bg_bottom"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 获取验证码 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 勾选表示同意 ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "中通招聘隐私政策.pdf",
  target: "_blank"
}, "用户协议和隐私政策", -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 获取验证码 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 勾选表示同意 ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "中通招聘隐私政策.pdf",
  target: "_blank"
}, "用户协议和隐私政策", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 登录 ")
const _hoisted_15 = {
  key: 3,
  class: "l-login__wechat"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 使用第三方登录 ")
const _hoisted_17 = { class: "l-login__wechat" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 使用第三方登录 ")
const _hoisted_19 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_z_header = _resolveComponent("z-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_z_header, { type: "transparent" }),
    _createElementVNode("div", {
      class: _normalizeClass(['l', { h5: _ctx.$isMobile }])
    }, [
      (!_ctx.$isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        (!_ctx.$isMobile)
          ? (_openBlock(), _createElementBlock("img", _hoisted_5))
          : _createCommentVNode("", true),
        (!_ctx.$isMobile)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 1,
              class: "l-login__form",
              ref: "formRef",
              model: _ctx.form,
              rules: _ctx.rules
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { prop: "phone" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.phone,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.phone) = $event)),
                      modelModifiers: { trim: true },
                      placeholder: "请输入手机号"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  prop: "verification",
                  style: {"position":"relative"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.verification,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.verification) = $event)),
                      modelModifiers: { trim: true },
                      placeholder: "请输入图形验证码"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("img", {
                      src: _ctx.codeImage,
                      alt: "",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getVerificationImg && _ctx.getVerificationImg(...args))),
                      width: "70",
                      height: "32",
                      class: "verification"
                    }, null, 8, _hoisted_6)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "code" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.code,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.code) = $event)),
                      placeholder: "请输入验证码"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_popover, {
                      visible: _ctx.verifyCodePopoverVisible,
                      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.verifyCodePopoverVisible) = $event)),
                      placement: "top-end",
                      width: 310,
                      trigger: "manual"
                    }, {
                      reference: _withCtx(() => [
                        (!_ctx.countIsVisible)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "text",
                              class: "l-login-code__button",
                              onClick: _ctx.handleVerifyClick
                            }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              type: "text",
                              class: "l-login-code__button"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("重新获取(" + _toDisplayString(_ctx.codeCount) + "s)", 1)
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }, 8, ["visible"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "name" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      modelValue: _ctx.form.checked,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.checked) = $event)),
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : (_openBlock(), _createBlock(_component_van_form, {
              key: 2,
              ref: "formRef"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_field, {
                  modelValue: _ctx.form.phone,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.phone) = $event)),
                  name: "phone",
                  label: "手机号",
                  type: "tel",
                  placeholder: "手机号",
                  rules: [
            { required: true, message: '手机号码不能为空', trigger: 'change' },
            { pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '手机号码格式不正确' }
          ]
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  modelValue: _ctx.form.verification,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.verification) = $event)),
                  name: "verification",
                  label: "图形验证码",
                  placeholder: "图形验证码",
                  type: "digit",
                  rules: [
            { required: true, message: '图形验证码不能为空' },
            { pattern: /^\d{4}$/, message: '验证码格式不正确' }
          ]
                }, {
                  button: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _ctx.codeImage,
                      alt: "",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.getVerificationImg && _ctx.getVerificationImg(...args))),
                      width: "70",
                      height: "32",
                      class: "verification"
                    }, null, 8, _hoisted_10)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  modelValue: _ctx.form.code,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.code) = $event)),
                  name: "code",
                  label: "验证码",
                  placeholder: "验证码",
                  type: "digit",
                  rules: [
            { required: true, message: '验证码不能为空' },
            { pattern: /^\d{4}$/, message: '验证码格式不正确' }
          ]
                }, {
                  button: _withCtx(() => [
                    (!_ctx.countIsVisible)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "text",
                          class: "l-login-code__button",
                          onClick: _ctx.handleVerifyClick
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "text",
                          class: "l-login-code__button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("重新获取(" + _toDisplayString(_ctx.codeCount) + "s)", 1)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_van_field, { name: "checkbox" }, {
                  input: _withCtx(() => [
                    _createVNode(_component_van_checkbox, {
                      modelValue: _ctx.form.checked,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.checked) = $event)),
                      shape: "square"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _hoisted_13
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512)),
        _createVNode(_component_el_button, {
          type: "primary",
          disabled: _ctx.loginButtonIsDisabled,
          class: "l-login__button",
          round: "",
          onClick: _ctx.handleSubmit
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        (!_ctx.$isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("img", {
                src: _imports_1,
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toWxLogin && _ctx.toWxLogin(...args)))
              }),
              _hoisted_16
            ]))
          : _createCommentVNode("", true),
        (!_ctx.$isMobile && _ctx.form.checked === true)
          ? (_openBlock(), _createBlock(_component_el_popover, {
              key: 4,
              placement: "top-start",
              width: 400,
              trigger: "click"
            }, {
              reference: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.toWxLogin && _ctx.toWxLogin(...args)))
                  }),
                  _hoisted_18
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("iframe", {
                  id: "template-iframe",
                  ref: "iframe",
                  src: _ctx.src,
                  width: "400",
                  height: "400",
                  style: {"border":"medium none"},
                  sandbox: "allow-forms allow-scripts allow-same-origin allow-popups allow-top-navigation allow-top-navigation-by-user-activation"
                }, null, 8, _hoisted_19)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 64))
}